define('v3/Common/Components/UnsupportedBrowser/UnsupportedBrowser.Component',[
	'knockout',
	'jquery',
	'text!v3/Common/Components/UnsupportedBrowser/UnsupportedBrowser.Component.html',
	'jquery.browser'
], function (ko, $, htmlString) {
	var isOldBrowser = ($.browser.msie && $.browser.versionNumber <= 11) || $.browser.msedge;

	function UnsupportedBrowserViewModel () {
		var self = this;

		self.isShown = ko.observable(localStorage['confirmedUnsupportedBrowser'] === 'true');

		self.close = function () {
			localStorage['confirmedUnsupportedBrowser'] = true;
			self.isShown(true);
		};

		if (isOldBrowser) {
			self.isShown.subscribe(function (isShown) {
				$('unsupported-browser').toggleClass('hidden', isShown);
			});

			self.isShown.valueHasMutated();
		}
	}

	var template = '<!-- empty -->';
	if (isOldBrowser) {
		template = htmlString;
	} else {
		$('unsupported-browser').remove();
	}

	return { viewModel: UnsupportedBrowserViewModel, template: template };
});

